import { memo, useCallback } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function ContactConfirmation() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToDashboard = useCallback(() => {
    navigate("/dashboard");
  }, [navigate]);

  return (
    <main
      className="container p-4"
      aria-label={t("contact.confirmation.aria")}
    >
      <div className="card shadow-lg border-0 rounded-2 text-center p-4">
        <h3 className="mb-3 text-success">
          <span aria-hidden="true">✅</span> {t("contact.confirmation.title")}
        </h3>
        <p>{t("contact.confirmation.body")}</p>
        <Button
          type="button"
          variant="primary"
          className="btn-fit-content px-4"
          onClick={handleGoToDashboard}
        >
          {t("contact.confirmation.goDashboard")}
        </Button>
      </div>
    </main>
  );
}

ContactConfirmation.displayName = "ContactConfirmation";

export default memo(ContactConfirmation);
